<template>
    <div>
        <Modal2
            v-if="showWhatsappChatStarterModal"
            @cancel="showWhatsappChatStarterModal = false"
            :title="$t('message.whatsappChatStart')"
            :showFooter="false"
        >
            <WhatsappChatStarter
                :default-phone-number="defaultPhoneNumber"
                phone-number-override
                @close="showWhatsappChatStarterModal = false"
            />
        </Modal2>
        <div class="external-widget-overlay" v-if="visible" :class="{ 'full-screen': fullScreen }">
            <div class="external-widget-container">
                <div class="external-widget-header">
                    <h3>{{ title }}</h3>
                    <a-button type="link" class="close-button" @click="handleClose">
                        <a-icon type="close" />
                    </a-button>
                </div>
                <div class="external-widget-content">
                    <iframe
                        :src="mode === 'url' ? url : undefined"
                        :srcdoc="mode === 'html' ? html : undefined"
                        frameborder="0"
                        class="widget-frame"
                        allow="camera; microphone; geolocation; fullscreen; autoplay; payment; vr; web-share; accelerometer; gyroscope; magnetometer; picture-in-picture; display-capture; clipboard-read; clipboard-write; usb; bluetooth; serial; hid; speaker-selection; encrypted-media; midi; sync-xhr"
                        sandbox="allow-same-origin allow-scripts allow-popups allow-forms allow-pointer-lock allow-orientation-lock allow-modals allow-downloads allow-popups-to-escape-sandbox allow-presentation allow-storage-access-by-user-activation allow-top-navigation allow-top-navigation-by-user-activation"
                        :data-webtab-id="webTabId"
                        :data-keep-alive="keepAlive"
                    ></iframe>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from "vuex";
import WhatsappChatStarter from "../../views/Pages/Integrations/meta-leads/WhatsappChatStarter.vue";
import Modal2 from "./Modal2.vue";
import SYSTEM_PUBSUB from "../../utils/systemPubSub";

const COMMANDS = {
    CLOSE_SUPSIS_EXTERNAL_WIDGET: "close-supsis-external-widget",
    OPEN_URL_IN_NEW_TAB: "open_url_in_new_tab",
    VIEW_RECORD: "view_record", // Tablo kaydını görüntüle
    START_CHAT: "start_chat", // Chat starter route'una yönlendir
    CREATE_TASK: "create_task", // Görev Oluştur
    SHOW_WINDOW: "show_window", // Pencere göster
    SHOW_CONTACT: "show_contact", // Kişi göster
    SHOW_MESSAGE: "show_message", // Mesaj göster
    MAKE_CALL: "make_call", // Çağrı yap
};
export default {
    name: "ExternalWidgetViewer",
    components: {
        Modal2,
        WhatsappChatStarter,
    },
    props: {
        title: {
            type: String,
            required: true,
        },
        url: {
            type: String,
            required: true,
        },
        visible: {
            type: Boolean,
            default: false,
        },
        fullScreen: {
            type: Boolean,
            default: false,
        },
        mode: {
            type: String,
            enum: ["url", "html"],
            default: "url",
        },
        html: {
            type: String,
            default: "",
        },
        keepAlive: {
            type: Boolean,
            default: false,
        },
        webTabId: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            cancels: [],
            showWhatsappChatStarterModal: false,
            defaultPhoneNumber: "",
        };
    },
    methods: {
        ...mapActions({
            addNewWindow: "app/addNewWindow",
        }),
        handleClose() {
            if (this.keepAlive) {
                // Keep-alive modda: sadece gizle, iframe'i kaldırma
                this.$emit("close", false);
            } else {
                // Normal mod: iframe'i tamamen kaldır
                this.$emit("close", true);
            }
        },
        handleWidgetMessage(event) {
            // Widget'tan gelen mesajları dinle
            if (event.data && event.data.type === COMMANDS.CLOSE_SUPSIS_EXTERNAL_WIDGET) {
                this.handleClose();
            } else if (event.data && event.data.type === COMMANDS.VIEW_RECORD) {
                const { title, tableId, recordId, multiple, autoClose } = event.data;
                this.addNewWindow({
                    id: recordId,
                    type: "table-record-viewer",
                    title,
                    payload: {
                        tableId,
                        recordId,
                    },
                    multiple,
                    autoClose,
                });
            } else if (event.data && event.data.type === COMMANDS.START_CHAT) {
                const { phoneNumber, close } = event.data;
                this.defaultPhoneNumber = phoneNumber;
                this.showWhatsappChatStarterModal = true;
                if (close) this.handleClose();
            } else if (event.data && event.data.type === COMMANDS.CREATE_TASK) {
                this.addNewWindow({
                    type: "chat-create-task",
                    title: this.$t("task.createTaskMessage"),
                });
            } else if (event.data && event.data.type === COMMANDS.SHOW_WINDOW) {
                const { type, title, payload, footer } = event.data;
                this.addNewWindow({
                    type,
                    title,
                    payload,
                    footer,
                });
            } else if (event.data && event.data.type === COMMANDS.SHOW_CONTACT) {
                const { title, contactId,close } = event.data;
                this.addNewWindow({
                    type: "show-visitor",
                    title,
                    payload: {
                        visitorId: contactId,
                    },
                    footer: false,
                });
                if (close) this.handleClose();
            } else if (event.data && event.data.type === COMMANDS.SHOW_MESSAGE) {
                const { notificationType, message, description } = event.data;
                this.$notification[notificationType]({
                    message,
                    description,
                });
            } else if (event.data && event.data.type === COMMANDS.MAKE_CALL) {
                const { phoneNumber, close } = event.data;
                SYSTEM_PUBSUB.publish(SYSTEM_PUBSUB.MESSAGE_TYPES.WEBPHONE_CALL_START, {
                    phoneNumber,
                });
                if (close) this.handleClose();
            } else if (event.data && event.data.type === COMMANDS.OPEN_URL_IN_NEW_TAB) {
                if (event.data.url && event.data.url !== "#") {
                    window.open(event.data.url, "_blank");
                }
            }
        },
    },
    mounted() {
        // Widget'tan gelen mesajları dinle
        const f = this.handleWidgetMessage;
        window.addEventListener("message", f);
        this.cancels.push(() => {
            window.removeEventListener("message", f);
        });
    },
    beforeDestroy() {
        // Event listener'ı temizle
        this.cancels.forEach((cancel) => cancel());
    },
    watch: {
        visible(newVal) {
            if (newVal) {
                if (!!document.querySelector(".notification-list-view.popup")) {
                    window.document.querySelector("#notifications > button")?.click();
                }
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.external-widget-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1000;
    display: flex;
    justify-content: center;
    align-items: center;

    &.full-screen {
        .external-widget-container {
            width: 100%;
            height: 100%;
            max-width: 100%;
            max-height: 100%;
        }
    }
}

.external-widget-container {
    background-color: #fff;
    border-radius: 4px;
    width: 90%;
    max-width: 1200px;
    height: 90vh;
    display: flex;
    flex-direction: column;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.external-widget-header {
    padding: 16px 24px;
    border-bottom: 1px solid #f0f0f0;
    display: flex;
    justify-content: space-between;
    align-items: center;

    h3 {
        margin: 0;
        font-size: 16px;
        color: rgba(0, 0, 0, 0.85);
    }

    .close-button {
        padding: 0;
        font-size: 16px;
    }
}

.external-widget-content {
    flex: 1;
    position: relative;
    overflow: hidden;
}

.widget-frame {
    width: 100%;
    height: 100%;
    border: none;
}
</style>
